// extracted by mini-css-extract-plugin
export var icon = "_4n-1";
export var subtext = "_4n-0";